module.exports = __webpack_public_path__ + "static/testimonial-e0fb6e008d60d0686ad0bd1530f98a34.jpg";